import { default as axios } from 'axios';
import * as Sentry from '@sentry/react';
import customHistory from '../history';
import { SERVER_URI_API } from './urls';
import { clearLocalStorage } from '../utils';

export const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = SERVER_URI_API;
axiosInstance.defaults.headers = { Authorization: `Bearer ${localStorage.getItem('auth-token')}` };

export const axiosInstanceNotAuthorized = axios.create();
axiosInstanceNotAuthorized.defaults.baseURL = SERVER_URI_API;

axiosInstance.interceptors.request.use(
    async (config) => {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
        };
        return config;
    },
    (error) => {
        Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status !== 401) {
            if (error.response) {
                Sentry.withScope((scope) => {
                    scope.setTag('http_status', error.response.status);
                    scope.setExtra('url', error.config.url);
                    scope.setExtra('method', error.config.method);
                    scope.setExtra('response_data', error.response.data);
                    Sentry.captureException(new Error(`HTTP error: ${error.response.status}`));
                });
            } else if (error.request) {
                Sentry.captureException(new Error('No response received from server'));
            } else {
                Sentry.captureException(error);
            }
        }

        if (
            error.response?.status === 401 &&
            (!localStorage.getItem('refresh-token') ||
                (error.response?.status === 401 &&
                    originalRequest.url === `auth/refresh-token/` &&
                    error.response.data.code === 'token_not_valid'))
        ) {
            clearLocalStorage();
            customHistory.push('/auth', { state: { form: true } });
            return Promise.reject(error);
        }

        if (
            error.response?.status === 401 &&
            !originalRequest._retry &&
            error.response.data.code === 'token_not_valid'
        ) {
            originalRequest._retry = true;
            return axiosInstance
                .post(`auth/refresh-token/`, {
                    refresh: localStorage.getItem('refresh-token'),
                })
                .then((res) => {
                    if (res?.status === 200) {
                        localStorage.setItem('auth-token', res.data.access);
                        localStorage.setItem('refresh-token', res.data.refresh);
                        axiosInstance.defaults.headers['Authorization'] = 'Bearer' + res.data.access;
                        return axiosInstance(originalRequest);
                    }
                });
        }
        return Promise.reject(error);
    },
);

axiosInstanceNotAuthorized.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response?.status !== 401) {
            if (error.response) {
                Sentry.withScope((scope) => {
                    scope.setTag('http_status', error.response.status);
                    scope.setExtra('url', error.config.url);
                    scope.setExtra('method', error.config.method);
                    scope.setExtra('response_data', error.response.data);
                    Sentry.captureException(new Error(`HTTP error: ${error.response.status}`));
                });
            } else if (error.request) {
                Sentry.captureException(new Error('No response received from server'));
            } else {
                Sentry.captureException(error);
            }
        }

        return Promise.reject(error);
    },
);
